import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonPopover,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonCard,
  IonRow,
  IonCol,
  IonInput,
  IonCardHeader,
  IonCardContent,
  IonCardTitle,
  IonCardSubtitle,
  IonTitle
} from '@ionic/react';
import './Studentmanagement.css';
import {RouteComponentProps} from "react-router";
import {AuthComponent} from "./_/AuthComponent";
import _ from "../_";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";
import Moment from 'react-moment';
import {calendar, pin} from 'ionicons/icons';
import {BaseComponent} from "./_/BaseComponent";

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent
}

class ResetPassword extends BaseComponent<Props, State> {
  static RoutePathname = /^\/resetpassword/gi;

  constructor(props: Props) {
    super(props);

    this.state = {
      showPopover: false,
      showPopoverEvent: null
    };
  }

  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  }

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  }

  handleInputChange(e) {
    // @ts-ignore
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.history.goBack();
              }} text="返回"/>
            </IonButtons>
            <IonTitle>重設密碼</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="stmgr" color="medium" scroll-y="false">
          <div className="panelpage">
            <div className="itembox">
              <IonList no-lines>
                <IonItem>
                  <IonLabel position="floating">舊密碼驗證</IonLabel>
                  <IonInput
                    name="password"
                    onInput={(e: any) => this.handleInputChange(e)}
                    placeholder="請輸入舊密碼"
                    type="text" required>
                  </IonInput>
                </IonItem>
                <IonItem>
                  <IonLabel position="floating">設定新密碼</IonLabel>
                  <IonInput
                    name="password"
                    onInput={(e: any) => this.handleInputChange(e)}
                    placeholder="請輸入密碼"
                    type="text" required>
                  </IonInput>
                </IonItem>
                <IonItem className="checkpass">
                  <IonLabel position="floating">確認新密碼正確</IonLabel>
                  <IonInput
                    name="password"
                    onInput={(e: any) => this.handleInputChange(e)}
                    placeholder="請再輸入設定的新密碼"
                    type="password" required>
                  </IonInput>
                </IonItem>

              </IonList>
              <IonRow responsive-sm>
                <IonCol>
                  <IonButton expand="block" color="primary" type="submit">
                    送出
                  </IonButton>
                </IonCol>
              </IonRow>
            </div>
          </div>
        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  conferenceDate: selectors.sessions.conferenceStart(state.sessions),
});

export default connect(
  mapStateToProps
)(ResetPassword);
